import { NoticeTypes } from '@genial/components';
import { Utils } from '@genial/utils';

export const getFixedIncomeAcceptQuotationNotice = (validDate?: Date) =>
  ({
    testId: 'fixedIncomeAcceptQuotationNotice',
    backgroundColor: Utils.ColorToken.WithOpacity('feedback.gen.lightest', 'opacity.medium'),
    type: 'alert',
    textObjects: (validDate
      ? [
          { text: 'Esta proposta é válida até as ', variant: 'regular' },
          {
            text: `${Utils.Mask.DateFormat(validDate, 'HH:mm')} do dia ${Utils.Mask.DateFormat(
              validDate,
              'dd/MM/yyyy'
            )}`,
            variant: 'bold',
          },
          { text: ', após esse prazo, o resgate será cancelado.', variant: 'regular' },
        ]
      : [
          { text: 'Esta proposta é válida por ', variant: 'regular' },
          { text: '24 horas', variant: 'bold' },
          {
            text: ', você só poderá realizar uma nova cotação após esta solicitação expirar.',
            variant: 'regular',
          },
        ]) as NoticeTypes.Props['textObjects'],
  } as const);
